import React from 'react';
import P from 'prop-types';

const LaunchExternal = ({ fill, className, size }) => {
  return (
    <svg
      className={className}
      style={{
        width: size,
        height: size,
      }}
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        className="nc-icon-wrapper"
      >
        <path d="M12 12L23 1" data-cap="butt" data-color="color-2" />
        <path d="M15 1L23 1 23 9" data-color="color-2" />
        <path d="M9 5L1 5 1 23 19 23 19 15" />
      </g>
    </svg>
  );
};

LaunchExternal.propTypes = {
  fill: P.string.isRequired,
  className: P.string,
  size: P.number,
};

export default LaunchExternal;
